import { Page } from '@/core/architecture'

import { ArtistPostsTemplate } from './template'
import { useViewModel } from './viewModel'

export const ArtistPosts: Page = () => {
  const { state, actions } = useViewModel()

  return <ArtistPostsTemplate state={state} {...actions} />
}
